import { createGlobalStyle } from 'styled-components';
import styled from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @font-face {
      font-family: HaasGrotDisp;
      src: url(${`${process.env.PUBLIC_URL}/assets/fonts/HaasGrotDisp-55Roman.otf`});
      font-weight: normal;
   }

   @font-face {
      font-family: HaasGrotDisp;
      src: url(${`${process.env.PUBLIC_URL}/assets/fonts/HaasGrotDisp-75Bold.otf`});
      font-weight: bold;
   }

   @font-face {
      font-family: NHaasGroteskTXPro;
      src: url(${`${process.env.PUBLIC_URL}/assets/fonts/NHaasGroteskTXPro-55Rg.ttf`});
      font-weight: normal;
   }

   @font-face {
      font-family: NHaasGroteskTXPro;
      src: url(${`${process.env.PUBLIC_URL}/assets/fonts/NHaasGroteskTXPro-75Bd.ttf`});
      font-weight: bold;
   }

     
.ant-select {
   .ant-select-selection {
       border: 1px solid #A8A8B1;
   }
   .ant-select-selection-selected-value {
       color: #fff;
   }
   .anticon {
       color: #fff;
   }
}
.ant-input::placeholder {
   color:#606570;
}
.ant-input-search-icon {
   color: #A8A8B1;
}
/* .ant-input-search {
   border: 1px solid #A8A8B1;
} */
.ant-input-search-icon ,.ant-calendar-picker-icon, .ant-calendar-range-picker-separator{
   color: #A8A8B1 !important;
}

   @keyframes ani {
      from {
         width: 52px;
         height:52px;
         border-color:#00f;
      }
      to {
         width:62px;
         height:62px;
         border-color:rgba(0,0,250,0.5);
      }
   }

   .animation {
      &::before {
         position:absolute;
         left:50%;
         top:50%;
         z-index:200000000;
         transform:translate(-50%,-50%);
         content:'';
         border:1px solid #00f;
         border-radius: .3125rem;
         width: 52px;
         height:52px;
         animation-name:ani;
         animation-duration:1s;
         animation-iteration-count:infinite;
         display:block;
      }
   }
  
   .table-wrapper {
      .ant-table-thead {
         th {
            color: #ffffff;
            font-weight: 500;
            text-align: left;
            background: #212121;
            border-bottom: 1px solid #A8A8B1;
            border-top: 1px solid #A8A8B1;
            -webkit-transition: background 0.3s ease;
            transition: background 0.3s ease;
         }
      }
      .ant-table-placeholder {
         position: relative;
         z-index: 1;
         margin-top: -1px;
         padding: 16px 16px;
         color: #606570;
         font-size: 14px;
         text-align: center;
         background: #0E0E0F;
         border-top: 1px solid #A8A8B1;
         border-bottom: 1px solid #A8A8B1;
         border-radius: 0 0 4px 4px;
         .ant-empty-normal{
            color: #606570 ;
         }
     }
     .ant-table {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      color: #A8A8B1;
      font-size: 14px;
      font-variant: tabular-nums;
      line-height: 1.5;
      list-style: none;
      -webkit-font-feature-settings: 'tnum', "tnum";
      font-feature-settings: 'tnum', "tnum";
      position: relative;
      clear: both;
     }
   }

   .plugin-detail-card-warpper {
      .ant-modal-footer {
         padding: 0px 16px;
         text-align: right;
         border-top: 0px;
         border-radius: 0 0 0px 2px;
         background-color: #29292C;
         .footer-wrapper {
            padding: 0rem 1rem 1rem 1rem;
            .custom-divider {
               border-top: 1px solid #B9B9B9;
            }
            .footer-content {
               margin-top: 1rem;
               display: flex;
               justify-content: center;
            }
            .footer-btn{
               background-color: #3A4FFF;
               color: #fff;
               width: 100%;
               border: none;
               font-size: 14px;
               margin-top: 1rem;
            }
         }
      }
      .d-flex {
            display: flex;
         }
         .bold {
            font-weight: bold;
         }
         .text-white {
            color: #fff;
         }
         .name-lable {
            margin-right: 5px;
         }
         .plugin-contents {
            flex-direction: column;
         }
         .card-version-label {
            margin-left: 10px;
         }
			.plugin-detail-icon {
				height: 4rem;
            margin-right: 1rem;
			}
			.plugin-card-img {
				width: 20rem;
				height: 15rem;
			}
         .info-circle {
				color: #fff;
				margin: 0px 5px 0px 5px;
			}
			.one-time-activation-icon {
				width: 16px;
				height: 20px;
				margin: 0px 5px 0px 5px;
			}
			.custom-free{
            color: white;
				border: 1px solid #00781b8c;
				border-radius: 12px;
				padding: 5px;
				margin-left: 5px;
				font-size: 12px !important;
				}
         .render-btn {
				width: 30%;
				border-radius: 15px;
    			height: 25px;
				margin-top: 10px;
			}
         .sub-header {
            margin-right: 5px;
         }
         .tooltip-container {
				margin: 0px;
			}
         .vertical-divider {
            border: 1px solid #75809B;
            width: 5px;
            border-bottom: none;
            border-right: none;
            border-top: none;
            height: 12px;
            margin: 5px 0px 0px 5px;
         }
         .verify-badge-wrapper{
				margin: 0px 5px 0px 5px;
				width: 20px;
				height: 20px;
				display: flex;
				justify-content: center;
            align-items:center;
			}
			.verify-badge-icon {
				width: 15px;
				height: 15px;
				margin-top: 3px;
			}
			.verify-badge-icon:hover{
				width: 20px;
				height: 20px;
			}
		}

      @media (max-width: 450px) {
         .plugin-detail-card-warpper {
            .plugin-detail-content-wrapper{
			      flex-direction: column;
                  .plugin-detail-icon {
                     height: 3rem;
                     width: 3rem;
                     margin:0rem 0rem 1rem 5rem;
			         }
               }
               .ant-modal-footer {
                     text-align: unset;
               }
               .ant-modal-close-x {
                  width: unset;
                  line-height: 72px;
                  margin-right: 1rem;
               }
          }
      }
`;

export const Wrapper = styled.div`
	// .adjust-height {
   //    padding-top: 30px;
   // }
`;


export default GlobalStyle;
